import React, { useState, useEffect } from 'react';
import EditItemDialog from "./EditItemDialog";
const CategoriesMenu = ({ categories, businessName, business_type }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  // Sort categories by display_order
  const sortedCategories = [...categories].sort((a, b) => a.display_order - b.display_order);

  // Set initial selected category on component mount
  useEffect(() => {
    if (sortedCategories.length > 0 && !selectedCategory) {
      setSelectedCategory(sortedCategories[0]);
      setFilteredItems(sortedCategories[0].items);
    }
  }, [categories]);

  // Update filtered items when selected category changes or search term changes
  useEffect(() => {
    if (selectedCategory) {
      if (searchTerm.trim() === '') {
        setFilteredItems(selectedCategory.items);
      } else {
        const filtered = selectedCategory.items.filter(item =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (item.description && item.description.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        setFilteredItems(filtered);
      }
    }
  }, [selectedCategory, searchTerm]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSearchTerm(''); // Clear search when switching categories
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleItemSaved = (updatedItem) => {
    setSelectedCategory(prev => ({
      ...prev,
      items: prev.items.map(item =>
        item.id === updatedItem.id ? updatedItem : item
      )
    }));
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2
    }).format(price);
  };

  const header = (business_type) => {
    if (business_type === 'Estate Agent') {
       return "Properties List"
    }
    return "Menu & Services";
  }

  return (
    <div className="container-fluid p-0">
      <h2 className="mb-2 poppin text-center  mt-5 mb-5">{header(business_type)}</h2>

      <div className="row g-0">
        {/* Left Sidebar - Categories */}
        <div className="col-md-3 col-lg-2">
          <div className="h-100 bg-light border-end shadow-sm">
            <div className="p-3 border-bottom">
              <h5 className="mb-0 fw-bold text-primary poppin">
                <i className="fas fa-list-alt me-2"></i>
                Categories
              </h5>
              {businessName && (
                <small className="text-muted d-block mt-1 poppin">
                  {businessName}
                </small>
              )}
              <div className="mt-3">
                <div className="input-group input-group-sm poppin">
                  <span className="input-group-text">
                    <i className="fas fa-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search items..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div>

            <div className="overflow-auto" style={{ maxHeight: 'calc(100vh - 150px)' }}>
              <ul className="list-group list-group-flush">
                {sortedCategories.map((category) => (
                  <li
                    key={category.id}
                    className={`list-group-item list-group-item-action border-0 py-3 px-3 ${selectedCategory?.id === category.id ? 'active' : ''
                      }`}
                    onClick={() => handleCategoryClick(category)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className={`mb-1 fw-semibold poppin ${selectedCategory?.id === category.id ? 'text-white' : 'text-dark'
                          }`}>
                          {category.name}
                        </h6>
                        <small className={`${selectedCategory?.id === category.id ? 'text-white-50' : 'text-muted'
                          }`}>
                          {category.items.length} item{category.items.length !== 1 ? 's' : ''}
                        </small>
                      </div>
                      {selectedCategory?.id === category.id && (
                        <i className="fas fa-chevron-right text-white"></i>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="border-top p-3">
              <small className="text-muted d-block poppin">
                <i className="fas fa-info-circle me-1"></i>
                {sortedCategories.length} categories total
              </small>
            </div>
          </div>
        </div>

        {/* Right Content - Items */}
        <div className="col-md-9 col-lg-10">
          <div className="p-4">
            {/* Header */}


            {/* Items Grid */}
            {selectedCategory && (
              <>
                {filteredItems.length === 0 ? (
                  <div className="text-center py-5">
                    <i className="fas fa-search fa-3x text-muted opacity-25 mb-3"></i>
                    <h4 className="text-muted mb-3 poppin">No items found</h4>
                    {searchTerm ? (
                      <p className="text-muted poppin">
                        No items found for "{searchTerm}". Try a different search term.
                      </p>
                    ) : (
                      <p className="text-muted poppin">
                        This category has no items available.
                      </p>
                    )}
                  </div>
                ) : (
                  <div className="row g-4">
                    {filteredItems.map((item) => (
                      <div key={item.id} className="col-md-6 col-lg-4 col-xl-4">
                        <div className="card h-100 shadow-sm border-0 hover-shadow transition-all">
                          <div className="card-body p-3">
                            {/* Item Header */}
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                <h5 className="card-title mb-3 lh- poppin">
                                  {item.name}
                                </h5>

                                {!item.is_available && (
                                  <span className="badge bg-danger small poppin">Out of Stock</span>
                                )}
                              </div>
                              <div className="text-end">
                                <div className="fw-bold text-success fs-5">
                                  {formatPrice(item.price)}
                                </div>
                                {item.estimated_prep_time_mins && (
                                  <small className="text-muted d-block poppin">
                                    <i className="fas fa-clock me-1"></i>
                                    {item.estimated_prep_time_mins} min
                                  </small>
                                )}
                              </div>
                            </div>

                            {/* Description */}
                            {item.description && (
                              <p className="card-text text-muted small mb-3 poppin">
                                {item.description}
                              </p>
                            )}

                            {/* Item Info */}
                            <div className="border-top pt-3">
                              {/* <div className="small text-muted mb-2 poppin">
                                <i className="fas fa-tag me-1"></i>
                                Category: {selectedCategory.name}
                              </div> */}
                              {/* <div>
                                <span className={`badge ${item.is_available ? 'bg-success' : 'bg-danger'}`}>
                                  <i className={`fas fa-${item.is_available ? 'check' : 'times'} me-1`}></i>
                                  {item.is_available ? 'Available' : 'Unavailable'}
                                </span>
                              </div> */}
                              <div className="d-flex gap-2 text-right">
                                <button
                                  className="btn btn-sm btn-primary"
                                  disabled={!item.is_available}
                                >
                                  <i className="fas fa-cart-plus me-1 poppin"></i>
                                  Order
                                </button>

                                <button
                                  className="btn btn-sm btn-outline-secondary"
                                  onClick={() => {
                                    setEditingItem(item);
                                    setEditOpen(true);
                                  }}
                                >
                                  <i className="fas fa-edit me-1"></i>
                                  Edit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            <EditItemDialog
              open={editOpen}
              item={editingItem}
              onClose={() => setEditOpen(false)}
              onSaved={handleItemSaved}
            />

          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesMenu;